import React, { useState, useEffect } from 'react';
import TitleBox from '@components/TitleBox';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal, notification } from 'antd';
import { handleStudent } from '@services';
import '../index.scss';
import { searchIgnoreCaseAndAccent } from '@utils/Functions/IgnoreCase';
import { dataOptionListStudentClassteacher as dataOption } from '@components/Filter/dataOption';
import { OPageIndex } from '@configs/pageSize';
import TabelComponent from '@components/Table';
import FilterComponent from '@components/Filter';
import { breadcrumbListStudentClassTeacher as breadcrumbItems } from '@components/Breadcrumb';
import { ColumnsListStudentClassTeacher as columns } from '@components/Table/Columns';

const DetailClassTeacher = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(20);
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');
  const handlePageChange = (page) => {
    setCurrentPage(page);
    const params = new URLSearchParams(window.location.search);
    if (params.has('pageIndex')) {
      params.set('pageIndex', page);
    } else {
      params.append('pageIndex', page);
    }
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    navigate(newUrl);
  };
  const [openExcel, setOpenExcel] = useState(false);
  const [data, setData] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);

  useEffect(() => {
    getDataTable();
  }, [location.search]);

  useEffect(() => {
    const myisActive = queryParams.get('isActive');
    if (myisActive) {
      if (myisActive === 'true') {
        setDataFilter([
          ...dataFilter,
          {
            key: 0,
            label: 'Trạng thái đang hoạt động',
            field: 'isActive',
            value: true,
          },
        ]);
      } else {
        setDataFilter([
          ...dataFilter,
          {
            key: 0,
            label: 'Trạng thái không hoạt động',
            field: 'isActive',
            value: false,
          },
        ]);
      }
    }
  }, []);

  const getDataTable = () => {
    const queryParams = new URLSearchParams(location.search);
    const mypageIndex = queryParams.get('pageIndex') || OPageIndex;
    const myisActive = queryParams.get('isActive');
    const code = queryParams.get('code');
    const myText = queryParams.get('text') || '';
    setTableLoading(true);
    handleStudent
      .GetListInClass(mypageIndex, myisActive, myText, code)
      .then((response: any) => {
        const { statusCode, data } = response;
        if (statusCode === 200) {
          setData(data.listData);
          setCurrentPage(Number(data.pageIndex));
          setTotalItems(Number(data.totalRecord));
          setTitle(data.className);
          setTableLoading(false);
        } else if (statusCode === 403) {
          notification.error({
            message: 'Lỗi',
            description: 'Đã có lỗi trong quá trình lấy dữ liệu !!',
          });
          setTableLoading(false);
        }
      })
      .catch((error) => {
        setTableLoading(false);
        console.error(error);
      });
  };
  const showModalExcel = () => {
    setOpenExcel(true);
  };

  const hideModalExcel = () => {
    setOpenExcel(false);
  };

  const handleDownloadExcel = async () => {
    const myisActive = queryParams.get('isActive');
    const myText = queryParams.get('text') || '';
    const code = queryParams.get('code') || '';
    handleStudent.downloadExcelStudentInClass(code, myisActive, myText);
    setOpenExcel(false);
  };
  const handlePayTuition = (record: any) => {
    console.log(record, 'record');
    navigate(`/tuition/details?id=${record.id}`);
  };

  const titleButton = '';
  const routerAdd = '';

  const [select1Value, setSelect1Value] = useState(undefined);
  const [select2Value, setSelect2Value] = useState(undefined);

  const handleSelect1Change = (value) => {
    setSelect1Value(value);
    setSelect2Value(undefined);
  };
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handleSubmitFilter = () => {
    setIsOpen(!isOpen);
    const params = new URLSearchParams(window.location.search);
    if (text) {
      params.set('text', text);
    } else {
      params.delete('text');
    }
    if (select2Value == 'true') {
      setDataFilter([
        {
          key: 1,
          label: 'Trạng thái đang hoạt động',
          field: 'isActive',
          value: true,
        },
      ]);
      if (params.has('isActive')) {
        params.set('isActive', 'true');
      } else {
        params.append('isActive', 'true');
      }
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      navigate(newUrl);
    } else if (select2Value == 'false') {
      setDataFilter([
        {
          key: 1,
          label: 'Trạng thái không hoạt động',
          field: 'isActive',
          value: false,
        },
      ]);
      if (params.has('isActive')) {
        params.set('isActive', 'false');
      } else {
        params.append('isActive', 'false');
      }
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      navigate(newUrl);
    }
  };

  const handleChangeInput = (value) => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('text')) {
      params.set('text', value);
    } else {
      params.append('text', value);
    }
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    navigate(newUrl);
  };
  const [dataFilter, setDataFilter] = useState([]);
  const handleDeleteFilter = (key) => {
    const updatedDataFilter = dataFilter.filter((item) => item.key !== key);
    setDataFilter(updatedDataFilter);
    const params = new URLSearchParams(window.location.search);
    if (params.has('isActive')) {
      params.delete('isActive');
    }
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    navigate(newUrl);
  };
  const customTotal = () => {
    return (
      <span className="pagination-table-title">Tổng {totalItems} học viên</span>
    );
  };
  return (
    <>
      <Modal
        title="Tải dữ liệu lớp học"
        open={openExcel}
        onOk={() => handleDownloadExcel()}
        onCancel={() => hideModalExcel()}
        okText="Xác nhận"
        cancelText="Hủy bỏ"
      >
        <p>
          Xác nhận tải xuống dữ liệu <strong>{totalItems} học viên</strong> ?
        </p>
      </Modal>
      <TitleBox
        breadcrumbItems={breadcrumbItems}
        title={'Danh sách học viên trong lớp ' + title}
        titleButton={titleButton}
        routerAdd={routerAdd}
      />
      <FilterComponent
        isOpen={isOpen}
        toggleDropdown={toggleDropdown}
        setText={setText}
        text={text}
        handleChangeInput={handleChangeInput}
        showModalExcel={showModalExcel}
        dataFilter={dataFilter}
        handleDeleteFilter={handleDeleteFilter}
        handleSelect1Change={handleSelect1Change}
        select1Value={select1Value}
        searchIgnoreCaseAndAccent={searchIgnoreCaseAndAccent}
        dataOption={dataOption}
        select2Value={select2Value}
        setSelect2Value={setSelect2Value}
        handleSubmitFilter={handleSubmitFilter}
        placeholderInput={'Tìm kiếm theo mã lớp học, tên lớp học'}
      />
      <div className="table">
        <TabelComponent
          columns={columns({ handlePayTuition })}
          data={data}
          tableLoading={tableLoading}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          totalItems={totalItems}
          customTotal={customTotal}
        />
      </div>
    </>
  );
};

export default DetailClassTeacher;
